/**
 * Class - The Compose class holds a property execute.
 * @param {Function} func - is the function used to check React.Component properties.
 */
class Compose {
    constructor(func) {
        this.execute = func;
    }
}

/**
 * function for checking if the obj is composable - meaning not
 * null, or has type with composeCheck property.
 * @param {Object} obj - the obj to check
 * @return {Boolean} - true if obj is not null, or if it has
 * type.composeCheck
 */

const composeCheck = (obj) => {
    if (obj) {
        if (obj.type) {
            if (obj.type.composeCheck instanceof Compose && obj.props) {
                return obj.type.composeCheck.execute(obj.props);
            }
        }
        return true;
    }
    return false;
};

/**
 * function compose creates a list of components to be rendered.
 * @param {Array} items - is an array of React.Component's, it also
 * excepts null values, and objects with the composeCheck property.
 * @return {Array} - list of components to be rendered.
 */

export const compose = (...items) => {
    let i = items.length;
    let list = [];
    let obj;
    while (i--) {
        obj = items[i];
        if (!composeCheck(obj)) {
            continue;
        }
        list.unshift(obj);
    }
    return list;
};

/**
 * function join returns a new list, that is
 * delimited by the component parameter.
 * @param {Array} list - list of components
 * @param {React.Component} component - the component used delimit
 * the list of components.
 * @return {Array} - array of components delimited by the component
 * parameter.
 */

export const join = (list, component) => {
    if (list instanceof Array) {
        let count = list.length;
        if (count > 1) {
            let l = [];
            count--;
            for (let i = 0; i < count; i++) {
                l.push(list[i]);
                l.push(component);
            }
            l.push(list[count]);
            return l;
        }
    }
    return list;
};
